var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100vh"}},[(_vm.flag)?_c('iframe',{attrs:{"width":"100%","height":"100%","scrolling":"no","src":_vm.src,"frameborder":"0"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }